import {
  Button,
  Layout,
  theme,
  Form,
  Input,
  Select,
  Spin,
  notification,
} from "antd";

import React, { useState, useCallback, useEffect } from "react";
import "../CreateRole/CreateRole.css";

import { Row, Col } from "antd";
import { Link, useNavigate } from "react-router-dom";
import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import DepartmentsApi from "../../common/Apis/DepartmentsApi";
import ProductApi from "../../common/Apis/ProductApi";
import AlertsApi from "../../common/Apis/AlertsApi";

const AddAlert = () => {
  const navigate = useNavigate();
  const { Content } = Layout;
  const [loadings, setLoadings] = useState(false);
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const handleGoBack = () => {
    navigate(-1);
  };

  const [Products, setProducts] = React.useState([]);
  const getProducts = useCallback(() => {
    ProductApi.Listproducts()
      .then((response) => {
        console.log(response);
        setProducts(response?.payloadDto);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  useEffect(() => {
    getProducts();
  }, [getProducts]);

  const handleSubmit = (data) => {
    setLoadings(true);
    let formData = JSON.stringify({
      alertType: data.alertType,
      description: data.description,
      severity: data.severity,
      productDTO: {
        id: data.productID,
      },
      tenantDTO: {
        id: decodedToken?.tenantId,
        tenantApiKey: decodedToken?.tenantApiKey,
      },
    });
    AlertsApi.CreateAlerts(formData)
      .then((response) => {
        setLoadings(false);
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Successfully</span>,
          description: "Create Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        return navigate("/masters/alerts");
      })
      .catch((err) => {
        if (err.apiError.status) {
          setLoadings(false);
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />

        <Content
          className="form-content nav-content"
          style={{
            margin: "16px 16px 0",
            padding: "30px",
            background: colorBgContainer,
          }}
        >
          <Form
            name="nest-messages"
            layout="vertical"
            className="FormClass"
            onFinish={handleSubmit}
          >
            <>
              <Row gutter={16}>
                <Col lg={8} md={12}>
                  <Form.Item
                    name="alertType"
                    label="Alert Type"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Alert Type.",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Alert Type"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>
                <Col lg={8} md={12}>
                  <Form.Item
                    name="severity"
                    label="Severity"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Severity.",
                      },
                    ]}
                  >
                    <Select
                      className="control-Select mb-1"
                      placeholder="Select Type"
                      options={[
                        { value: "LOW", label: "LOW" },
                        { value: "MODERATE", label: "MODERATE" },
                        { value: "HIGH", label: "HIGH" },
                        { value: "CRITICAL", label: "CRITICAL" },
                        { value: "INFORMATIONAL", label: "INFORMATIONAL" },
                        { value: "WARNING", label: "WARNING" },                         
                      ]}
                    />
                  </Form.Item>
                </Col>
                <Col lg={8} md={12}>
                  <Form.Item
                    name="productID"
                    label="Product Name *"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please Select Product Name.",
                      },
                    ]}
                  >
                    <Select
                      className="control-Select mb-1"
                      placeholder="Select Product Name"
                    >
                      {Products && (
                        <>
                          {Products?.map((option, index) => (
                            <option key={index} value={option?.id}>
                              {option?.productName}
                            </option>
                          ))}
                        </>
                      )}
                    </Select>
                  </Form.Item>
                </Col>
                <Col lg={8} md={12}>
                  <Form.Item
                    name="description"
                    label="Description"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Description.",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Description"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>
              </Row>

              <div className="d-flex justify-content-end pt-5">
                <Link
                  type="primary"
                  to={""}
                  onClick={handleGoBack}
                  className="btn btn-primary btn-back"
                >
                  Back
                </Link>

                <Button
                  type="primary"
                  htmlType="submit"
                  className="btn btn-primary btn-save"
                >
                  Create {loadings == true && <Spin className="px-2" />}
                </Button>
              </div>
            </>
          </Form>
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};
export default AddAlert;
